"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Sep 21 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var utils_1 = require("../../../core/utils");

var ResearchTypeEnum_1 = require("../../../data-pairing/model/ResearchTypeEnum");

var CompetitorProductConverter_1 = require("../../../product/conversions/CompetitorProductConverter");

var CompetitorConverter_1 = require("../../../site/conversions/CompetitorConverter");

var CompetitorSiteConverter_1 = require("../../../site/conversions/CompetitorSiteConverter");

var SimpleZonePrice_1 = require("../../model/SimpleZonePrice");

var CompetitorProductDTO_1 = require("../../model/dto/CompetitorProductDTO");

var CompetitorPriceConverter_1 = require("../CompetitorPriceConverter");

var CompetitorProductDTOConverter_1 = require("./CompetitorProductDTOConverter");
/**
 * Implementation of CompetitorProductDTOConverterImpl
 *
 * @author RV
 * @author Jaroslav Sevcik
 */


var CompetitorProductDTOConverterImpl =
/*#__PURE__*/
function (_CompetitorProductDTO) {
  _inherits(CompetitorProductDTOConverterImpl, _CompetitorProductDTO);

  function CompetitorProductDTOConverterImpl(competitorProductConverter, competitorPriceConverter, competitorSiteConverter, competitorConverter) {
    var _this;

    _classCallCheck(this, CompetitorProductDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CompetitorProductDTOConverterImpl).call(this));
    _this.competitorProductConverter = competitorProductConverter;
    _this.competitorPriceConverter = competitorPriceConverter;
    _this.competitorSiteConverter = competitorSiteConverter;
    _this.competitorConverter = competitorConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(CompetitorProductDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new CompetitorProductDTO_1.CompetitorProductDTO(conversions.toBigNumber(source.ratio), conversions.toBigNumber(source.charger), conversions.asObjectList(source, 'modifiedPrices', function (competitorPrice) {
        return new SimpleZonePrice_1.SimpleZonePrice(utils_1.Utils.asString(conversions.toClassReferenceId(competitorPrice.zoneId)), conversions.toBigNumber(competitorPrice.price));
      }), conversions.asObjectList(source, 'competitorReferencePrices', function (competitorPrice) {
        return new SimpleZonePrice_1.SimpleZonePrice(utils_1.Utils.asString(conversions.toClassReferenceId(competitorPrice.zoneId)), conversions.toBigNumber(competitorPrice.price));
      }), conversions.asEnumOpt(source.researchType, ResearchTypeEnum_1.ResearchTypeEnum), source.competitorPrice ? this.competitorPriceConverter.toObject(source.competitorPrice, conversions) : null, this.competitorProductConverter.toObject(source.competitorProduct, conversions), source.competitorSite ? this.competitorSiteConverter.toObject(source.competitorSite, conversions) : null, this.competitorConverter.toObject(source.competitor, conversions));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        ratio: conversions.fromBigNumber(source.ratio),
        charger: conversions.fromBigNumber(source.charger),
        competitorReferencePrices: conversions.asObjectArray(source, 'competitorReferencePrices', function (competitorZonePrice) {
          return {
            zoneId: utils_1.Utils.asString(conversions.toClassReferenceId(competitorZonePrice.zoneId)),
            price: conversions.fromBigNumber(competitorZonePrice.price)
          };
        }),
        modifiedPrices: conversions.asObjectArray(source, 'modifiedPrices', function (competitorZonePrice) {
          return {
            zoneId: utils_1.Utils.asString(conversions.toClassReferenceId(competitorZonePrice.zoneId)),
            price: conversions.fromBigNumber(competitorZonePrice.price)
          };
        }),
        researchType: source.researchType,
        competitorPrice: source.competitorPrice ? this.competitorPriceConverter.toDocument(source.competitorPrice, conversions) : null,
        competitorProduct: this.competitorProductConverter.toDocument(source.competitorProduct, conversions),
        competitorSite: source.competitorSite ? this.competitorSiteConverter.toDocument(source.competitorSite, conversions) : null,
        competitor: this.competitorConverter.toDocument(source.competitor, conversions)
      });
      return result;
    }
  }]);

  return CompetitorProductDTOConverterImpl;
}(CompetitorProductDTOConverter_1.CompetitorProductDTOConverter);

CompetitorProductDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __param(2, typescript_ioc_1.Inject), __param(3, typescript_ioc_1.Inject), __metadata("design:paramtypes", [CompetitorProductConverter_1.CompetitorProductConverter, CompetitorPriceConverter_1.CompetitorPriceConverter, CompetitorSiteConverter_1.CompetitorSiteConverter, CompetitorConverter_1.CompetitorConverter])], CompetitorProductDTOConverterImpl);
exports.CompetitorProductDTOConverterImpl = CompetitorProductDTOConverterImpl;